import Button from "../../atoms/Button";
import classnames from "classnames";
import SVGS from "../../atoms/svgs";
import "./styles.scss";

const Cards = (props) => {
  const classNames = classnames("cards", {
    "cards--hasBackground": props.background,
    "cards--centered": props.centered,
    [`cards--${props.alt}`]: props.alt,
  });

  return (
    <div className={`${classNames} cards--${props.theme} `}>
      {props.cards.map(function (card, index) {
        const Icon = card.svg ? SVGS[card.svg] : null;

        return (
          <div
            className="Card"
            key={`card-${index}`}>
            <div className="Card__main">
              {card.imageUrl && (
                <img
                  src={card.imageUrl}
                  className="Card__image"
                  alt={card.title}
                />
              )}
              <div className="Card__container">
                {card.svg && (
                  <Icon
                    className="Card__icon"
                    title={card.title}
                  />
                )}
                {card.title && (
                  <div
                    className="Card__title"
                    dangerouslySetInnerHTML={{ __html: card.title }}></div>
                )}
                {card.subtitle && <div className="Card__subtitle">{card.subtitle}</div>}
                {card.price && (
                  <div
                    className="Card__price"
                    dangerouslySetInnerHTML={{ __html: card.price }}></div>
                )}
                {card.content && (
                  <div
                    className="Card__content"
                    dangerouslySetInnerHTML={{ __html: card.content }}></div>
                )}
              </div>
            </div>
            {card.link && (
              <div className="Card__button">
                <Button
                  primary
                  full
                  label={card.label}
                  link={card.link}
                  dataQa="landing-home-test"
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Cards;
